<template>
  <div class="modal show_modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content" style="margin-top: -10px">
        <div class="modal-header">
          <div class="container">
            <button
              type="button"
              style="position: absolute"
              @click="closeModal()"
              class="btn btn-small"
            >
              <v-icon class="">mdi-arrow-left</v-icon>
              {{ $t("Back") }}
            </button>
            <div class="text-center">
              <h4>{{ $t("List Customer") }}</h4>
            </div>
          </div>
        </div>
        <div class="modal-body" style="height: 85vh">
          <div class="container">
            <div class="row">
              <div class="col-md-6">
                <form v-on:submit.prevent="getCustomer">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      v-model="search"
                      @keyup="getCustomer()"
                      :placeholder="
                        $t('Find by name, email, phone number.')  
                      "
                    />
                    <div
                      class="input-group-append pointer"
                      @click="getCustomer"
                    >
                      <span class="input-group-text">
                        <icon icon="search" />
                      </span>
                    </div>
                  </div>
                </form> 
               
                <VuePerfectScrollbar class="customer-wrap mt-2">

                  <loading v-if="loading" class="mt-5"></loading>
                   <nodata
                    class="text-center"
                    v-if="(customers.length == 0) & !loading"
                  ></nodata>
                  <div
                    class="customer-list shadow-sm m-1"
                    v-for="(cust, index) in customers"
                    :key="index"
                    @click="customer = cust"
                    :class="{'active': customer.id == cust.id}"
                  >
                   
                    <div class="row">
                      <div class="col-4">
                         <p> <strong> {{ cust.name }}</strong></p>
                        <p>#: {{ cust.id }}</p></div>
                      
                      <div class="col-8">
                        <p><icon icon="smartphone" :size="15" /> ​{{ cust.phone || 'none'}}</p> 
                        <p><icon icon="mail" :size="15" /> {{ cust.email || 'none' }}</p>
                        </div>
                    </div> 
                  </div>
                </VuePerfectScrollbar>
              </div>
              <div class="col-md-6">
                <div class="row h-100">
                  <div
                    class="col-md-12"
                    style="margin-top: auto; margin-bottom: auto"
                  >
                    <div class="m-auto p-5 text-center">
                      <template v-if="customer.name">
                        <h1>{{ customer.name }}</h1>
                        <p>Email: {{ customer.email || 'none' }}</p>
                        <p>Phone Number: {{ customer.phone || 'none' }}</p>
                        <br>
                        <button @click="setCustomer" class="btn btn-block shadow-sm btn-select p-2">
                          {{ $t("Select") }}
                        </button>
                      </template>
                      <template v-else>
                        <div>
                          <img src="" alt="" />
                          <p>{{ $t("Please Select customer!") }}</p>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer text-center"></div>
      </div>
    </div>
  </div>
</template>
<style lang="css">
.btn-select {
  margin: 20px;
  background-color: green;
  color: white;
  padding: 10px !important;
}
.customer-ul li {
  display: inline;
  list-style: none;
  padding-right: 10px;
}
.customer-wrap {
  height: calc(100vh - 220px);
}
.customer-wrap > .active{
  background-color: #6c757d17;
}
.modal-customer {
  min-width: 500px;
}
.customer-list {
  max-width: 96%;
  padding: 10px;
  cursor: pointer;
}
</style>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import store from "@/store"; 
export default {
  name: "ModalCustomer",
  components: {
    VuePerfectScrollbar,
  },
  data: () => ({
    search: "",
    customer: {},
  }),
  computed: {
    restaurant() {
      return store.getters["restaurant/restaurant"];
    },
    loading() { 
      return store.getters["customer/loading"];
    },
    customers() {
      return store.getters["customer/customers"] || [];
    },
    meta_customers() {
      return store.getters["customer/meta"] || [];
    },
  },
  methods: {
    closeModal() {
      return this.$emit("input", false);
    },
    async getCustomer() {
      await store.dispatch("customer/fetch_all_customer", {
        type_id: this.restaurant.id,
        search: this.search,
      });
    },
    setCustomer(){ 
      this.$emit("selected", this.customer);
      return this.$emit("input", false);
    }
  },
  mounted() {
    this.getCustomer();
  },
};
</script>